import { PercentageRingAndDescription, PercentageRingAndDescriptionProps } from './percentageRingAndDescription';

interface MetricConditionalProperties {
	/**
	 * The colour of the ring
	 */
	ringColour: string;
	/**
	 * The colour of the percentage text inside the ring
	 */
	percentageTextColour: string;
	/**
	 * Text to help interpret the metric's value
	 */
	supportingText: string;
}

interface MetricConditionalPercentageRingAndDescriptionProps extends Omit<PercentageRingAndDescriptionProps, 'ringColour' | 'textColour'> {
	/**
	 * Whether or not the metric value is considered low
	 */
	isMetricValueLow: boolean;
	/**
	 * The properties to use when the metric value is low
	 */
	lowMetricValueProperties: MetricConditionalProperties;
	/**
	 * The properties to use when the metric value is not low
	 */
	normalMetricValueProperties: MetricConditionalProperties;
}

/**
 * Component displaying a percentage ring and description with colours and supporting text dependent on whether rate is considered low
 */
export const MetricConditionalPercentageRingAndDescription: React.FC<MetricConditionalPercentageRingAndDescriptionProps> = (props) => {
	const {
		isMetricValueLow,
		lowMetricValueProperties,
		normalMetricValueProperties,
	} = props;

	let ringColour: string;
	let percentageTextColour: string;
	let supportingText: string;

	if (isMetricValueLow) {
		({ ringColour, percentageTextColour, supportingText } = lowMetricValueProperties);
	} else {
		({ ringColour, percentageTextColour, supportingText } = normalMetricValueProperties);
	}

	return (
		<PercentageRingAndDescription
			{...props}
			ringColour={ringColour}
			textColour={percentageTextColour}
			supportingText={supportingText}
		/>
	);
};